import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AnalyticsAdminSettingsAction } from '../../domains/analyticsAdminSettings/actions.types';

import type { AnalyticsAdminSettingsLifecycle } from './types';

const initialState: AnalyticsAdminSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<AnalyticsAdminSettingsLifecycle, AnalyticsAdminSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
